import { render, staticRenderFns } from "./OrderViewPage.vue?vue&type=template&id=c3fdf69a&"
import script from "./OrderViewPage.vue?vue&type=script&lang=js&"
export * from "./OrderViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports